import axios from 'axios'
import { createClient } from './api'

export const MAX_INSPECTION_UPLOAD_BYTES = 25 * 1024 * 1024

export function inspectionFileError(file: File): string | undefined {
  if (
    !file.name.toLowerCase().endsWith('.pdf') ||
    (file.type && file.type !== 'application/pdf')
  ) {
    return 'Please select a PDF file'
  }
  if (!file.size) return 'Please select a nonempty PDF file'
  if (file.size > MAX_INSPECTION_UPLOAD_BYTES) {
    return 'Please select a PDF no larger than 25 MiB'
  }
}

export async function uploadInspection(
  file: File,
  onUploadProgress?: (event: ProgressEvent) => void
): Promise<string> {
  const error = inspectionFileError(file)
  if (error) throw new Error(error)

  const { data } = await createClient().get<{
    url: string
    fields: Record<string, string>
  }>('/checkout/inspection-upload-url')
  const formData = new FormData()
  for (const [field, value] of Object.entries(data.fields)) {
    formData.set(field, value)
  }
  formData.set('file', file)

  await axios.post(data.url, formData, { onUploadProgress })
  return data.fields.key
}
